<template>
  <div>
    <navbar v-if="common"></navbar>
    <navbarCommon v-if="!common"></navbarCommon>
    <div class="main">
      <router-view></router-view>
    </div>
    <myfooter></myfooter>
  </div>
</template>

<script>
import Navbar from "@/components/navbar.vue";
import navbarCommon from "@/components/navbarCommon.vue";
import myfooter from "@/components/footer.vue";

export default {
  name: "layout",
  components: {Navbar, myfooter,navbarCommon},
  data(){
    return{
       common:true
    }
  },
  watch: {
    '$route':{
      handler(to, from) {
        let arrList=["about","solutions","products","cases","contact"]
        console.log('Route changed from', from, 'to', to);
        if(arrList.indexOf(to.name)!=-1){
          this.common=false
        }else{
          this.common=true
        }
      },
      deep:true,
      immediate:true
    }
  }
}
</script>

<style scoped>
.main {
  /*padding-top: 60px;*/
}
</style>
